import { Link } from "react-router-dom";
import { FadeUp, Overline } from "@/components/Reveal";
import { Magnetic } from "@/components/Magnetic";

const OFFERINGS = [
  "High-memory professional GPUs",
  "Data-centre accelerators",
  "Training and inference hardware",
  "Server-qualified GPU platforms",
  "Multi-GPU systems",
];

export const GpuFeature = () => (
  <section id="gpu" className="relative py-16 lg:py-20 bg-white overflow-hidden" data-testid="gpu-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-center">
      <FadeUp className="relative order-2 lg:order-1">
        <div className="relative hairline overflow-hidden shadow-soft bg-white">
          <img
            src="/assets/hardware/enterprise-gpu-accelerator-cards.webp"
            alt="Brand-neutral enterprise GPU accelerator cards"
            width="1200"
            height="654"
            className="w-full h-[320px] lg:h-[380px] object-cover"
            loading="lazy"
            data-testid="gpu-feature-image"
          />
          <div className="absolute bottom-0 inset-x-0 px-5 py-3 bg-white/85 backdrop-blur-sm border-t border-midnight/10 flex justify-between items-center">
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-midnight">Professional &amp; Enterprise GPU Compute</p>
            <p className="text-[10px] font-medium uppercase tracking-[0.12em] text-midnight/40">Accelerator Class</p>
          </div>
        </div>
        <div className="absolute -top-3 -left-3 w-20 h-20 border-t-2 border-l-2 border-gold/60 pointer-events-none" />
      </FadeUp>

      <FadeUp delay={0.1} className="order-1 lg:order-2">
        <Overline>Enterprise GPU / AI Infrastructure</Overline>
        <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-midnight">
          Compute without compromise.
        </h2>
        <ul className="mt-7 space-y-3">
          {OFFERINGS.map((o) => (
            <li key={o} className="flex items-center gap-3 text-midnight/70">
              <span className="w-4 h-px bg-gold" />
              {o}
            </li>
          ))}
        </ul>
        <p className="mt-7 text-midnight/55 text-sm leading-relaxed border-l-2 border-gold/60 pl-5">
          Looking for a specific GPU? Submit the manufacturer part number, required quantity and destination. Our commercial team will assess availability — subject to commercial confirmation.
        </p>
        <Magnetic className="mt-7">
          <Link
            to="/request?category=Enterprise%20GPU"
            data-testid="gpu-discuss-requirement"
            className="inline-block bg-midnight text-white text-sm font-medium px-8 py-3.5 hover:bg-midnight-light transition-colors"
          >
            Discuss GPU Requirement
          </Link>
        </Magnetic>
      </FadeUp>
    </div>
  </section>
);
